module.exports = __webpack_public_path__ + "img/registration.2067710c.png";